import { Icon, Modal, useTranslation } from '@testsigma/atoms';
import { useContext } from 'react';
import { UFTElementsContext } from '../../list/uft-elements-context';

export const UFTElementImportProcessingPopup = () => {
  const { t } = useTranslation();
  const { currentElementFile, updateCurrentPopup } =
    useContext(UFTElementsContext);

  return (
    <Modal
      isOpen={true}
      closeOnEscape
      closeOnOutsideClick
      onClose={() => updateCurrentPopup(null)}
      className='min-w-[480px] max-w-[480px] relative'>
      <Icon
        name='close'
        className='text-lg text-primary-900 cursor-pointer absolute top-5 right-5 !rounded-xl'
        onClick={() => updateCurrentPopup(null)}
      />
      <div className='text-lg font-medium text-unique-600 mb-6'>
        {t(
          currentElementFile ? 'element.update.elements' : 'uft.element.import',
        )}
      </div>
      <div className='flex items-center flex-col mb-7 mt-6'>
        <div className='empty-page-loader !h-16 !w-16 !max-h-16 !max-w-16 !border-t-primary-500' />
        <div className='text-center mt-3 text-base font-medium text-secondary-600'>
          {t('element.updated.started')}
        </div>
        <div className='text-center mt-10 text-xs text-neutral-700'>
          {t('element.updated.started.desc')}
        </div>
      </div>
    </Modal>
  );
};
